import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { IonSelect, ModalController } from '@ionic/angular';
import { ClientsService } from 'src/app/business-service/clients/clients.service';
import { ContactsService } from 'src/app/business-service/contacts/contacts.service';
import { LeadsService } from 'src/app/business-service/leads/leads.service';
import { ENTITY_NAMES, LEAD_SOURCE_VALUE, ORGANIZATION_TYPES, RECORD_STATUS_VALUES, TRAVEL_SERVICES } from '../../shared/constants/api-constants';
import { GlobalService } from '../../shared/services/global/global.service';
import { LovDataService } from '../../shared/services/lov-data/lov-data.service';
import { ModalsService } from '../../shared/services/modals/modals.service';
import { ComponentReloadService } from '../../shared/services/reload/component-reload.service';
import { ResponseNotificationService } from '../../shared/services/response-notification/response-notification.service';
import { InputValidationsService } from '../../shared/services/validations/input-validations.service';
import { InventoryService } from 'src/app/business-service/inventory/inventory.service';
import { ItineraryService } from 'src/app/business-service/quote/itinerary.service';
import { DmcPackageService } from 'src/app/business-service/dmc-package/dmc-package.service';
import { DmcQuotesService } from 'src/app/business-service/dmc-quotes/dmc-quotes.service';

@Component({
  selector: 'app-dmc-lead-form',
  templateUrl: './dmc-lead-form.component.html',
  styleUrls: ['./dmc-lead-form.component.scss'],
})
export class DmcLeadFormComponent implements OnInit {

  leadForm!: FormGroup;
  leadFormIsDirty: boolean = false;

  editLeadId: any;
  leadDetails: any;
  leadId: any;
  packageIds: any;

  leadStatus: any;
  leadSource: any;
  leadPriority: any = [];
  assignedUser: any;
  travelServices: any = [];

  personsFromContact: any = [];

  disableServiceType: boolean = false;

  constructor(
    private _modalController: ModalController,
    private _fb: FormBuilder,
    private _leadService: LeadsService,
    private _lovDataService: LovDataService,
    private _globalService: GlobalService,
    private _responseNotificationService: ResponseNotificationService,
    private _contactService: ContactsService,
    private _validationService: InputValidationsService,
    private _reloadService: ComponentReloadService,
    private _clientService: ClientsService,
    private _modalPopupService: ModalsService,
    private _router: Router,
    private _inventoryService: InventoryService,
    private _dmcQuoteService: DmcQuotesService,
  ) { }

  async ngOnInit() {
    //TODO: Call all LOVs first Here
    this.leadStatus = await this.getLovData("LeadStatus");
    this.leadSource = await this.getLovData("LeadSource");
    this.leadPriority = await this.getLovData("TaskPriority");
    let organization = await this._globalService.getLoggedInOrgDetails();
    this.packageIds = organization.organizationDetails.packageId;

    let defaultUser = localStorage.getItem('jti');
    this.leadForm = this._fb.group({
      clientId: [''],
      firstName: [''],
      firstNameWithSalutation: [null, [Validators.required]],
      lastName: ['', [this._validationService.noSpacesValidator()]],
      phoneNumber: [{ countryCode: '+91', phone: '' }, [Validators.required]],
      alternativePhoneNumber: [{ countryCode: '+91', phone: '' }, [this.notSameAsPhoneNumberValidator()]],
      email: ['', [Validators.email, Validators.required]],
      source: ['', Validators.required],
      status: ['New'],
      priority: ['High', Validators.required],
      ownership: [defaultUser, Validators.required],
      ownershipName: [""],
      companyName: ["", [Validators.required]],
      travelServices: [[], [this._validationService.arrayNotEmptyValidator()]],
      type: [ORGANIZATION_TYPES.DMC],
      leadNote: [''],
      ownershipRole: [null],
      organizationId: [null],
      id: [null],
      leadId: [null]
    });

    this.leadForm.valueChanges.subscribe(() => {
      this.leadFormIsDirty = this.leadForm.dirty;
    });

    if (this.editLeadId) {
      this._leadService.getLead(this.editLeadId).subscribe({
        next: (lead) => {
          this.leadDetails = lead;
          this.patchLeadFormData(lead);
        },
        error: (error) => {
          console.error(error);
          this._responseNotificationService.showMessage("Failed to get lead, try again later.");
        }
      })
    }
  }

  // Custom validations
  notSameAsPhoneNumberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const phoneControl = this.leadForm?.get('phoneNumber');
      const alternativePhoneNumberControl = control;
      if (!alternativePhoneNumberControl?.value?.phone) {
        return null;
      }

      if (phoneControl && alternativePhoneNumberControl && (phoneControl.value?.phone === alternativePhoneNumberControl.value?.phone)) {
        return { notSameAsPhoneNumber: true };
      }
      return null;
    }
  }

  get todayDateTime() {
    return this._globalService.getTodaysDateTime();
  }

  patchLeadFormData(formData: any) {
    this.leadForm.patchValue(formData);
    this.leadForm.get('firstNameWithSalutation')?.patchValue({ firstName: formData.firstName, salutation: formData.salutation })

    if (formData.source === LEAD_SOURCE_VALUE.EXISTING_CUSTOMER || formData.source === LEAD_SOURCE_VALUE.COLD_CALL) {
      this.leadForm.get('source')?.disable();
    }
  }

  async getLovData(catogory: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this._lovDataService.getLovData(catogory).subscribe((data) => {
        resolve(data);
      }, (error) => {
        reject(error);
      });
    })
  }

  // Search person from contacts and patch
  searchExistingPerson(phoneNumber: any) {
    this._clientService.getClientFromPhoneNumber(phoneNumber.phone).subscribe((data) => {
      if (data.status !== false) {
        this.patchClientInformation(data);
      } else {
        this.leadForm.patchValue({
          firstNameWithSalutation: null,
          lastName: "",
          email: "",
          source: ""
        })
        this.leadForm.get('firstNameWithSalutation')?.enable();
        this.leadForm.get('source')?.enable();
        this.searchPersonInContacts(phoneNumber);
      }
    })
  }

  searchPersonInContacts(phoneNumber: any) {
    this._contactService.getContactFromPhoneNumber(phoneNumber.phone).subscribe((data) => {
      if (data.status != false) {
        if (data.length === 1) {
          this.patchContactInformation(data[0]);
        } else {
          this.personsFromContact = data;
        }
        return true;
      } else {
        return false;
      }
    })
  }

  personFromContactSelected(person: any) {
    this.patchContactInformation(person);
    this.personsFromContact = []
  }

  patchContactInformation(person: any) {
    this.leadForm.patchValue({
      firstNameWithSalutation: { firstName: person.firstName, salutation: person.salutation || null },
      lastName: person.lastName,
      phoneNumber: {
        countryCode: person.phoneCountryCode,
        phone: person.phoneNumber
      },
      email: person.email
    })
    this._responseNotificationService.showMessage("Existing Person In Contacts");
  }

  patchClientInformation(client: any) {
    this.leadForm.patchValue({
      firstNameWithSalutation: { firstName: client.firstName, salutation: client.salutation || null },
      lastName: client.lastName,
      phoneNumber: {
        countryCode: client.phoneNumber.countryCode,
        phone: client.phoneNumber.phone
      },
      email: client.email,
      source: LEAD_SOURCE_VALUE.EXISTING_CUSTOMER
    })

    this.leadForm.get('firstNameWithSalutation')?.enable();
    this.leadForm.get('source')?.disable();

    this._responseNotificationService.showMessage("Existing Client");
  }

  async closeModal(submitted: boolean = false) {
    if (this.leadFormIsDirty && !submitted) {
      if (await this._globalService.confirmActionPopup("You have unsaved data, confirm to close!", undefined, "Confirm")) {
        this.dismissModal(submitted);
      }
    } else {
      this.dismissModal(submitted);
    }
  }

  dismissModal(submitted: boolean) {
    this._modalController.dismiss({
      'dismissed': true,
      'submitted': submitted
    });
  }

  openSelect(selectElem: IonSelect) {
    selectElem.open();
  }

  assignSelectedUser(event: any) {
    this.leadForm.get("ownershipName")?.setValue(`${event.firstName} ${event.lastName}`);
    this.leadForm.get("ownershipRole")?.setValue(`${event.roleIdentifier}`);
  }

  clearServices() {
    this.leadForm.get("travelServices")?.setValue([]);
  }

  async onSubmit(): Promise<boolean> {
    if (this.leadForm.valid) {
      try {
        const formData = await this.serializeFormData(this.leadForm.getRawValue());
        // If using recommended itinerary
        const recommendedItinerary = this._globalService.getRecommendedItinerary();
        if (recommendedItinerary) {
          if (!this.checkValiditityToUseRecommendedItinerary(formData)) {
            return false;
          }
        }

        if (this.editLeadId) {
          // Update existing lead
          const data = await this._leadService.updateLead(this.editLeadId, formData).toPromise();
          if (data) {
            this.leadDetails = data;
            this._responseNotificationService.showMessage("Lead Updated Successfully.");
            this.dismissModal(true);
            this._reloadService.triggerLeadsReload();
            return true;
          }
        } else {
          // Create new lead
          const data = await this._leadService.createLead(formData).toPromise();
          if (data) {
            this.leadDetails = data;
            this._responseNotificationService.showMessage("Lead Created Successfully.");
            this.leadForm.reset();
            this.leadId = data.leadId;
            // If using recommended itinerary
            if (recommendedItinerary) {
              await this.useSelectedRecommendedItinerary(recommendedItinerary, data);
              return false;
            }
            this._router.navigate([`dmc-leads/details/${this.leadId}`]);
            this.dismissModal(true);
            return true;

          }
        }
      } catch (error) {
        console.error("Error during form submission:", error);
        this._responseNotificationService.showMessage("Something went wrong, please try again!", true);
        return false; // Submission failed
      }
    } else {
      // Form is invalid
      this.leadForm.markAllAsTouched();
      this._globalService.scrollToFirstInvalidControl();
      this._globalService.customAlert("Form is invalid, please fill all required fields.");
      return false; // Submission failed
    }

    return false; // Default failure in case of unexpected behavior
  }

  private async serializeFormData(formData: any) {
    const serializedData = { ...(this.leadDetails || {}), leadNotes: [] };
    Object.assign(serializedData, {
      ...formData,
      firstName: formData.firstNameWithSalutation?.firstName,
      salutation: formData.firstNameWithSalutation?.salutation,
    });
    if (formData.leadNote) {
      serializedData.leadNotes.push({
        note: formData.leadNote,
        userId: localStorage.getItem("jti"),
        createDate: this._globalService.getTodaysDateTime()
      });
    }
    return serializedData;
  }

  checkValiditityToUseRecommendedItinerary(leadDetails: any): boolean {
    if (!leadDetails.travelServices?.includes(TRAVEL_SERVICES.SIGHTSEEING)) {
      this._globalService.customAlert("You cannot use recommended itinerary without Sightseeing service.");
      return false;
    }
    return true;
  }

  async useSelectedRecommendedItinerary(itinerary: any, leadDetails: any) {
    if (itinerary.recommendedItineraryType === ENTITY_NAMES.INVENTORY_ITINERARY) {
      try {
        const data = await this._inventoryService.getInventoryItinerary(itinerary.recommendedItineraryId).toPromise();
        const itineraryDetails: any = {
          destination: data.itineraryDetails.destination,
          itineraryName: data.itineraryDetails.itineraryName,
          totalDays: data.itineraryDetails.totalDays,
          note: data.itineraryDetails.note,
          inventoryItineraryId: itinerary.recommendedItineraryId || null,
          packageId: itinerary.recommendedItineraryId || null,
          recommendedOrganizationId: itinerary.recommendedOrganizationId || null,
          leadId: leadDetails.leadId,
          status: RECORD_STATUS_VALUES.DRAFT
        };

        const response = await this._dmcQuoteService.selectRecommendedItinerary(ENTITY_NAMES.INVENTORY_ITINERARY, itineraryDetails).toPromise();
        this._router.navigate([`dmc-leads/details/${leadDetails.leadId}`]);
        await this.dismissModal(false);
        await this._modalPopupService.openDmcQuoteForm(leadDetails.leadId, response.itineraryDetails.itineraryId);

      } catch (error) {
        console.error("Error in useSelectedRecommendedItinerary:", error);
      }
    }
  }


  async saveAndNext() {
    if (await this.onSubmit()) {
      await this._modalPopupService.closeAllModals();
      await this._modalPopupService.openDmcQuoteForm(this.leadDetails?.leadId, null);
    }
  }

  async saveAndNew() {
    if (await this.onSubmit()) {
    }
  }

}
